import React from 'react';

import type { BaseLineIconProps, ColorType } from '../../utils';
import { assetTypeToBackgroundColor } from '../../utils';
import { Icon } from '../BaseIcon/Icon';

export const LineIcon = ({
  type,
  size = 'sm',
  disabled = false,
  backgroundColorHexCode,
}: BaseLineIconProps & {
  backgroundColorHexCode?: ColorType;
}): JSX.Element => {
  const color = disabled ? 'gray' : assetTypeToBackgroundColor[type];
  const dataTestId = `icon-${disabled ? 'disabled' : 'active'}`;
  return (
    <Icon
      data-testid={dataTestId}
      type={`${type}Line`}
      size={size}
      primaryColor={color}
      backgroundColor={backgroundColorHexCode}
      includeSecondaryMark={false}
    />
  );
};
